package com.essntl.features.invoice.ui.addeditinvoice.utils

import kotlinx.coroutines.Deferred

/**
 * Awaits all deferreds in the list and calls the [block] on each deferred's result.
 * If an exception occurs, all deferreds are cancelled and the function returns false.
 * Otherwise, it returns true.
 *
 * @param block The block to call on each deferred's result.
 * @return True if all deferreds were awaited successfully, false otherwise.
 */
suspend fun <T> List<Deferred<Result<T>>>.onEachSafeAwait(block: suspend (T) -> Unit): Boolean =
    try {
        map { deferred ->
            val item = deferred.await().getOrThrow()
            block(item)
        }

        true
    } catch (e: Exception) {
        forEach { it.cancel() }

        false
    }